import * as angular from "angular";
import * as _ from "lodash";
import {getApp} from 'firebase/app';
import {getAuth, signInWithCustomToken} from 'firebase/auth';
import {getDatabase, ref, off, onValue} from "firebase/database";
import {Database, DatabaseReference, DataSnapshot, goOffline, goOnline} from "@firebase/database";
import {FirebaseApp} from "@firebase/app";
import {
  ILocationService,
  ILogService,
  IPromise,
  IQService,
  IRequestConfig,
  IRootScopeService,
  ITimeoutService
} from "angular";
import {BringozObject} from "./bringoz-object";
import {BringozStoreService} from "./bringoz-data-store-service.service";
import {LocalStoreService} from "./local-store-service.service";
import {FirebaseChannelResponse} from "./models/firebase-channel-response.model";
import {AnalyticsService} from "../commons/services/analytics-service.service";
import {HttpService} from "../commons/services/http-service.service";
import {FirebaseAuthResponseModel} from "./models/firebase-auth-response.model";
import {SitesRequestsService} from "../sites/services/sites-requests.service";
import {DataStoreConfig} from "./models/datastore-config.model";
import {PushNotificationsConfig} from "./models/push-notifications-config.model";
import {FirebaseService} from "./firebase.service";
import {Inject} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {SplitService} from "../commons/services/split-service.service";

export class SyncService {

  $$subscribedToUpdates: {
    [key: string]: { // Store name
      keys?: {
        [key: string]: BringozObject<any>[] // Entity ID -> List of bringoz objects
      },
      channel?: DatabaseReference
    }
  } = {};

  // $$channel: FirebaseAuthResponseModel;
  // $$firebaseApp: FirebaseApp;
  // $$database: Database;
  isFirebaseOnline: boolean;

  constructor(private httpService: HttpService,
              private localStoreService: LocalStoreService,
              private $q: IQService,
              private $log: ILogService,
              private analyticsService: AnalyticsService,
              private $location: ILocationService,
              private $rootScope: IRootScopeService,
              private $timeout: ITimeoutService,
              private firebaseService: FirebaseService,
              private bringozStoreService: BringozStoreService,
              private splitService: SplitService,
              private sitesRequestsService: SitesRequestsService) {
  }

  request<T>(api: string, config: IRequestConfig, dataStore: DataStoreConfig, options?: { [key: string]: string }, doUpdate?: boolean): IPromise<any> {

    const deferred = this.$q.defer();

    this.httpService.request(api, config, options)
      .then((response) => {
          if (!_.isUndefined(dataStore) && doUpdate) {

            const list = _.get(response, 'list') || _.get(response, 'content');
            const data = list ? list : response;
            const entities: T[] = _.isArray(data) ? data : [data];
            const entitiesToUpdate: T[] = [];

            _.forEach(entities, (v) => {
              const idKey: string = dataStore.keyName;
              const currentDataStoreValue: T = this.getByKey<T>(dataStore, v[idKey]);
              if (!!currentDataStoreValue && this.doUpdate<T>(currentDataStoreValue, v, dataStore)) {
                entitiesToUpdate.push(v);
              }
            })

            if (entitiesToUpdate.length) {
              this.$rootScope.$broadcast('ON_CHANGE_ENTITIES', entitiesToUpdate, dataStore);
            }

            this.save(dataStore, entities);
            this.updateCycle<T>(dataStore, entities);
          }

          deferred.resolve(response);
        }, (error) => {
          this.$log.error('[SyncService] Fail to perform the request', error);
          deferred.reject(error);
        }
      );

    return deferred.promise;
  }

  subscribe<T>(bringozObject: BringozObject<T>) {

    const dataStore: DataStoreConfig = bringozObject._dataStore;
    const storeName: string = dataStore.objectStoreName;
    const pushNotificationsConfiguration: PushNotificationsConfig = bringozObject._PN;

    let store = this.$$subscribedToUpdates[storeName];

    if (_.isUndefined(store)) {

      this.$$subscribedToUpdates[storeName] = {
        keys: {},
        channel: undefined
      }

      store = this.$$subscribedToUpdates[storeName];

      if (_.isUndefined(pushNotificationsConfiguration)) {
        this.$log.warn('[SyncService] Push notification configuration not found for entity type : ' + storeName + ', The data ' +
          'will not update automatically \n --> @subscribe');
      } else {

        const channelPath: string = pushNotificationsConfiguration.database;

        if (channelPath) {

          let isBranchEntity: boolean = pushNotificationsConfiguration.isBranchEntity;
          // let branchIds: string[] = bringozObject._branchIds;
          let branchIds: string[] = this.splitService.getUserSiteBranchIds() || [];


          this.getDatabaseReference(channelPath, isBranchEntity, branchIds)
            .then((databaseReference: DatabaseReference) => {

                store.channel = databaseReference;

                if (_.isObject(databaseReference)) {

                  let isInit: boolean = true;
                  onValue(databaseReference, (snapshot: DataSnapshot) => {

                    if (!!isInit) {
                      isInit = false;
                      return;
                    }

                    // FIXME
                    this.$timeout().then(() => {

                      const data = snapshot.val() as FirebaseChannelResponse<T>;
                      const keys = store.keys;

                      if (_.isArray(data.list) && !_.isUndefined(data.action)) {

                        this.$log.debug(`[SyncService] Entity "${channelPath}" "${data.action}"`, data.list);

                        switch (data.action) {
                          case 'created':
                            this.handleCreated(dataStore, data.list, pushNotificationsConfiguration);
                            break;
                          case 'changed':
                            this.handleChanges(keys, dataStore, data.list, pushNotificationsConfiguration);
                            break;
                          case 'partialChanged':
                            this.handlePartialChanges(keys, dataStore, data.list, pushNotificationsConfiguration);
                            break;
                        }

                      } else {
                        this.$log.error('[SyncService] List returned from Firebase is not an array and/or the action ' +
                          'type resolved to undefined! --> @subscribe', databaseReference);
                      }
                    });
                  });

                } else {
                  this.$log.error('[SyncService] Store channel error, store type:', store);
                }
              }
            );

        } else {
          this.$log.error('[SyncService] Channel database path resolved to undefined, Check the PN configuration constant!. \n' +
            'Entity type : ' + storeName + ', PN config : --> @subscribe', pushNotificationsConfiguration);
        }

      }

    }

    let unique = bringozObject._id;
    let keys = store.keys;
    //The container that hold all the bringoz object references per entity bound to the view.
    let container = keys[unique];

    if (!container) {
      keys[unique] = [];
      container = keys[unique];
    }

    //FIXME
    if (_.isUndefined(container)) {


      this.$log.error('[SyncService] Bringoz reference list container resolved to undefined!. --> @subscribe');

    } else {

      container.push(bringozObject);

      //Will remove the bringozObject listeners from the queue when the bound scope is destroyed.
      //If the keys list (list of unique ID's per entity type) is empty, will close the Firebase channel
      //as well.
      return () => {

        const index = _.findIndex(container, (_reference) => {
          return _.isEqual(_reference, bringozObject);
        });

        if (!_.isEqual(index, -1)) {

          container.splice(index, 1);

          if (_.isEmpty(container)) {
            _.unset(keys, bringozObject._id);
          }

        } else {
          this.$log.warn('[SyncService] For some reason the bringoz object was not found in the subscribed list...', bringozObject);
        }

        if (_.isEmpty(keys)) {

          if (!_.isUndefined(store)) {

            const channelPath: string = pushNotificationsConfiguration.database;
            this.destroyEntityChannel(store.channel, channelPath);
            _.unset(this.$$subscribedToUpdates, storeName);
          }
        }
      };
    }
  }

  subscribeChannel(database: string): IPromise<DatabaseReference> {
    return this.getDatabaseReference(database);
  }


  destroyFirebase() {
    this.$log.debug('[SyncService] Destroy firebase');

    _.forOwn(this.$$subscribedToUpdates, (storeValue: any, storeKey) => {
      if (storeValue.channel) {
        off(storeValue.channel);
      }
    });
    this.$$subscribedToUpdates = {};

    this.isFirebaseOnline = false;
    return this.firebaseService.destroyFirebase();
  }

  firebaseGoOnline(): void {
    const dataBase = this.firebaseService.database;
    if (this.isFirebaseOnline) {
      return;
    } else if (dataBase) {

      goOnline(dataBase);
      this.isFirebaseOnline = true;

      // Sync all BringozObjects from server to the latest data.
      _.forOwn(this.$$subscribedToUpdates, (value: any, storeName) => {
        _.forOwn(value.keys, (bringozObjectList, entityId) => {

          _.forEach(bringozObjectList, (bringozObjectRef) => {
            if (_.isFunction(bringozObjectRef.$get)) {
              bringozObjectRef.$get();
            }
          })

        })
      })
      this.$log.debug(`[SyncService] Firebase Pushes Turned ON`);
    } else {
      this.$log.debug(`[SyncService] this.$$database Reference is missing`);
    }
  }

  firebaseGoOffline(): void {
    const dataBase = this.firebaseService.database;
    if (dataBase) {
      goOffline(dataBase);
      this.isFirebaseOnline = false;

      this.$log.debug(`[SyncService] Firebase Pushes Turned OFF`);
    } else {
      this.$log.debug(`[SyncService] this.$$database Reference is missing`);
    }
  }

  destroyEntityChannel(databaseReference: DatabaseReference, entityName: string) {

    this.$log.debug(`[SyncService] Destroy "${entityName}" entity channel`);

    this.analyticsService.trackEvent('Entity channel', 'Destroy', entityName, this.$location.path());
    //FIXME
    return !!databaseReference ? off(databaseReference) : this.$q.when();
  }

  save<T>(dataStore: DataStoreConfig, entities: T[]): void {
    this.bringozStoreService.save(dataStore, entities);
  }

  private getByKey<T>(dataStore: DataStoreConfig, key: string): T {
    return this.localStoreService.getByKey<T>(dataStore, key);
  }

  private getDatabaseReference(entityName: string, isBranchEntity?: boolean, branchIds?: string[]): IPromise<DatabaseReference> {

    this.$log.debug(`[SyncService] Connect to "${entityName}" channel`);

    let path: string;

    const channel = this.firebaseService.channel;
    const database = this.firebaseService.database;

    if (isBranchEntity && branchIds && branchIds.length === 1) {
      path = `${channel.channelId}/branch/${branchIds[0]}/${entityName}`;
    } else {
      path = `${channel.channelId}/${entityName}`;
    }

    const databaseReference: DatabaseReference = ref(database, path);

    this.analyticsService.trackEvent('Entity channel', 'Connect', entityName, this.$location.path());
    return this.$q.when(databaseReference);
  }

  private handleCreated<T>(dataStore: DataStoreConfig, entities: T[], _pushNotificationsConfiguration: PushNotificationsConfig): void {

    this.save(dataStore, entities);

    if (entities.length) {
      this.$rootScope.$broadcast('ON_CREATE_ENTITIES', entities);
    }
  }

  private handleChanges<T>(_keys, dataStore: DataStoreConfig, entities: T[], _pushNotificationsConfiguration: PushNotificationsConfig) {

    const unique: string = dataStore.keyName;
    const entitiesChanged: T[] = [];
    const storeName: string = dataStore.objectStoreName;

    if (unique && storeName) {

      if (_.isArray(entities)) {

        _.forEach(entities, (_entity) => {

          if (!!_entity) {

            //Returns from firebase and causes payload errors.
            _.unset(_entity, '$id');
            _.unset(_entity, '$priority');

            const entityId = _.get(_entity, unique);
            const bringozObjectReferenceList = _.get(_keys, entityId);

            // Check if there is a current data store value and updates it.
            const currentDataStoreValue: T = this.getByKey<T>(dataStore, entityId);

            if (!!currentDataStoreValue && this.doUpdate<T>(currentDataStoreValue, _entity, dataStore)) {
              entitiesChanged.push(_entity);
            } else {
              this.$log.debug('[SyncService] An update is not required.', _entity);
            }

            // Check if there are bringozObject references that needs the external update.
            if (_.isUndefined(bringozObjectReferenceList)) {
              this.$log.debug('[SyncService] Bringoz object reference not found for entity:', _entity);
            } else {
              if (_.isArray(bringozObjectReferenceList)) {
                _.forEach(bringozObjectReferenceList, (_bringozObjectReference) => {
                  _bringozObjectReference.$externalUpdate(_entity);
                });
              } else {
                this.$log.error('[SyncService] BringozObject reference list is not an array!. --> @handleChanges');
              }
            }
          }

        });

      } else {
        this.$log.error('[SyncService] Entities is not an array!. --> @$$handleChanges');
      }
    } else {
      this.$log.error('[SyncService] An issue occurred with the data store configuration object! --> @$$handleChanges');
    }

    // If there are subscribers to changes on bringozList reference. (using bringozList -> $onChanges)
    if (entitiesChanged.length) {
      this.save(dataStore, entitiesChanged);
      this.$rootScope.$broadcast('ON_CHANGE_ENTITIES', entitiesChanged, dataStore);
    }

  }

  private handlePartialChanges<T>(_keys, dataStore: DataStoreConfig, entities: T[],
                                  _pushNotificationsConfiguration: PushNotificationsConfig) {

    const unique: string = dataStore.keyName;
    const entitiesChanged: T[] = [];
    const storeName: string = dataStore.objectStoreName;

    if (unique && storeName) {

      if (_.isArray(entities)) {
        _.forEach(entities, (_entity) => {

          if (!!_entity) {

            //Returns from firebase and causes payload errors.
            _.unset(_entity, '$id');
            _.unset(_entity, '$priority');

            const entityId = _.get(_entity, unique);
            const bringozObjectReferenceList = _.get(_keys, entityId);
            const currentDataStoreValue: T = this.getByKey<T>(dataStore, entityId);
            const updatedValue: T = angular.copy(currentDataStoreValue);

            if (!!currentDataStoreValue && this.doUpdate<T>(currentDataStoreValue, _entity, dataStore)) {
              _.forOwn(_entity, (value, key) => {
                updatedValue[key] = value;
              })
              entitiesChanged.push(updatedValue);
            } else {
              this.$log.debug('[SyncService] An update is not required.', _entity);
            }

            // Check if there are bringozObject references that needs the external update.
            if (!!updatedValue && _.isUndefined(bringozObjectReferenceList)) {
              this.$log.debug('[SyncService] Bringoz object reference not found for entity:', _entity);
            } else {
              if (_.isArray(bringozObjectReferenceList)) {
                _.forEach(bringozObjectReferenceList, (_bringozObjectReference) => {
                  _bringozObjectReference.$externalUpdate(updatedValue);
                });
              } else {
                this.$log.warn('[SyncService] BringozObject reference list is not an array!. --> @handlePartialChanges', _entity);
              }
            }
          }

        });
      } else {
        this.$log.error('[SyncService] Entities is not an array!. --> @$$handleChanges');
      }
    } else {
      this.$log.error('[SyncService] An issue occurred with the data store configuration object! --> @$$handleChanges');
    }

    // If there are subscribers to changes on bringozList reference. (using bringozList -> $onChanges)
    if (entitiesChanged.length) {
      this.save(dataStore, entitiesChanged);
      this.$rootScope.$broadcast('ON_CHANGE_ENTITIES', entitiesChanged, dataStore);
    }

  }

  private doUpdate<T>(referenceEntity: T, firebaseEntity: T, dataStore: DataStoreConfig): boolean {

    const referenceUpdatedAt =  referenceEntity['updatedAt'] ||  referenceEntity['updatedTime']|| referenceEntity['analysisTime'];
    const firebaseUpdateAt = firebaseEntity ['updatedAt'] || firebaseEntity['updatedTime']  || firebaseEntity['analysisTime'];

    if (_.isUndefined(referenceUpdatedAt) || _.isUndefined(firebaseUpdateAt)) {

      const storeName: string = dataStore.objectStoreName;

      // Advisory only: the update proceeds either way. Some backend DTOs (e.g. ServiceAreas)
      // legitimately have no updatedAt, so this fires on every push and is kept at debug level.
      if (_.isUndefined(storeName)) {
        this.$log.debug('[SyncService] \"Updated At / Updated Time" property is missing from the entity. \n ' +
          'This property is used by --> SyncServiceProvider@subscribe@$$handleChanges@$$doUpdate ,'
          + ' In order to validate the necessity of the internal update cycle thus ' +
          'reducing the $digest cycle.', referenceEntity);
      } else {
        this.$log.debug('[SyncService] \"Updated At / Updated Time" property is missing from the entity of type (by data store name) : '
          + storeName + '. \n' +
          ' This property is used by --> SyncServiceProvider@subscribe@$$handleChanges@$$doUpdate ,'
          + ' In order to validate the necessity of the internal update cycle thus reducing the $digest cycle.');
      }

      return true;
    }

    return (!_.isEqual(referenceUpdatedAt, firebaseUpdateAt) && new Date(firebaseUpdateAt) > new Date(referenceUpdatedAt));
  }

  private updateCycle<T>(dataStore: DataStoreConfig, entities: T[]) {

    const unique: string = dataStore.keyName;
    const storeName: string = dataStore.objectStoreName;

    if (unique && storeName) {

      let store = this.$$subscribedToUpdates[storeName];

      if (store) {

        const keys = store.keys;

        _.forEach(entities, (entity) => {

          const entityId = entity[unique];
          const bringozObjectReferenceList: BringozObject<T>[] = keys[entityId];

          if (_.isUndefined(entityId)) {
            this.$log.warn('[SyncService] Entity ID not found for data store : ' + storeName + ', ' +
              'The entity observed is :', entity);
          }

          if (bringozObjectReferenceList) {

            _.forEach(bringozObjectReferenceList, (bringozObjectReference) => {
              bringozObjectReference.$externalUpdate(entity);
            });

          }

        });


      }

    } else {
      this.$log.error('[SyncService] An issue occurred with the data store configuration object! \n ' +
        '--> @$$updateCycle');
    }

  }
}

angular
  .module('bringoz.admin.persistence')
  .service('syncService', SyncService);
